import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #DATEPICKER-FIELD
\*------------------------------------ */
[popover] {
  /**
  * Reset all default user agent styles - position: fixed, outline, margin: auto etc
  */
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * 1) Form field that consists of an input that triggers a datepicker popup
 */
.cat-c-datepicker-field {
  position: relative;
  /**
   * Disabled state
   */
  /**
  * 1) Padding for input field in warning and error state 
  */
}
.cat-c-datepicker-field.cat-c-datepicker-field--disabled {
  cursor: not-allowed;
}
.cat-c-datepicker-field.cat-is-warning, .cat-c-datepicker-field.cat-is-error {
  --cat-input-warning-icon--inset-inline-end: var(--cat-space-3x-large);
  --cat-input-warning-icon--inset-block-end: var(--cat-space-small);
  --cat-input-padding-horiz-end: var(--cat-space-6x-large);
}
.cat-c-datepicker-field.cat-c-datepicker-field--small.cat-is-warning, .cat-c-datepicker-field.cat-c-datepicker-field--small.cat-is-error {
  --cat-input-warning-icon--inset-block-end: calc(var(--size-base-unit) * 1.125);
}
.cat-c-datepicker-field.cat-c-datepicker-field--readonly {
  pointer-events: none;
}
.cat-c-datepicker-field.cat-c-datepicker-field--readonly cat-input-field {
  --cat-input-pointer-events: none;
  --cat-input-readonly--label: var(--cat-theme-color-content-disabled);
  --cat-input-field-readonly--border-color: var(--cat-theme-color-border-readonly);
  --cat-input-field-readonly--icon-color: var(--cat-theme-color-content-disabled);
}
.cat-c-datepicker-field.cat-c-datepicker-field--disabled cat-input-field {
  --cat-input-field-readonly--border-color: var(--cat-theme-color-border-disabled);
}

/**
 * Input field
 */
cat-input-field {
  --cat-input-pointer-events: auto;
  --cat-theme-color-form-input--placeholder: var(--cat-theme-color-content-subtle);
  --cat-input-field-readonly--border-color: var(--cat-theme-color-form-border);
  /**
   * Disabled state
   */
  /**
   * Active state
   */
}
cat-input-field :disabled {
  pointer-events: none;
}
.cat-c-datepicker-field--is-active cat-input-field {
  --cat-input-field--outline: 2px solid var(--cat-theme-color-focus-ring);
  --cat-input-field--outline-offset: 2px;
}

/**
 * Input (and other optional elements) wrapper
 */
.cat-c-datepicker-field__body {
  position: relative;
}

.cat-c-datepicker-field__popup-wrapper {
  display: none;
  z-index: var(--cat-z-index-400);
}

/**
 * Popup body, containing the calendar w/ optional time selector list
 */
.cat-c-datepicker-field__popup-body {
  box-shadow: var(--cat-theme-box-shadow-lg);
  border-radius: var(--cat-border-radius-lg);
  background: var(--cat-theme-color-background-default);
  pointer-events: auto;
  max-height: var(--cat-auto-position-max-height);
  max-width: var(--cat-auto-position-max-width);
  overflow: var(--cat-auto-position-overflow);
}

/**
 * Field footer
 */
.cat-c-datepicker-field__footer {
  border-block-start: 1px solid var(--cat-theme-color-border-default);
  padding: var(--cat-space-medium) var(--cat-space-x-large);
  grid-column-start: span 2;
  display: flex;
}

/**
* Field note in the footer
*/
.cat-c-datepicker-field__field-note {
  flex-basis: 100%;
}
.cat-c-datepicker-field--small .cat-c-datepicker-field__field-note {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

cat-time-selector-list {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/**
 * Accessibility instructions
 */
.cat-c-datepicker-field__instructions {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Apply  loaders  style
 */
.cat-c-input-field--loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}

.cat-c-datepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
  position: relative;
}
.cat-c-datepicker__input-loader .cat-c-datepicker__icon-loader {
  position: absolute;
  inset-inline-end: var(--cat-space-medium);
  inset-block-end: calc(var(--size-base-unit) * 1.25);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-datepicker-field--large .cat-c-datepicker__input-loader .cat-c-datepicker__icon-loader {
  inset-block-end: var(--cat-space-medium);
}
.cat-c-datepicker-field--medium .cat-c-datepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}
.cat-c-datepicker-field--small .cat-c-datepicker__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

::part(input-field) {
  --cat-input-placeholder-color: var(--cat-theme-color-content-subtle);
}

.cat-c-datepicker-field:not(.cat-c-datepicker-field--has-field-note) .cat-c-datepicker-field__field-note-slot, .cat-c-datepicker-field:not(.cat-c-datepicker-field--has-error) .cat-c-datepicker-field__error-slot, .cat-c-datepicker-field:not(.cat-c-datepicker-field--has-warning) .cat-c-datepicker-field__warning-slot {
  display: none;
}
`;
       